import { render, staticRenderFns } from "./AppointmentSchedule.html?vue&type=template&id=98893088&scoped=true&external"
import script from "./AppointmentSchedule.js?vue&type=script&lang=js&external"
export * from "./AppointmentSchedule.js?vue&type=script&lang=js&external"
import style0 from "./AppointmentSchedule.scss?vue&type=style&index=0&id=98893088&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98893088",
  null
  
)

export default component.exports